/* global EventSource */
import qs from 'querystring';
import { React, PT, connect, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Segment, Dropdown, Button, Grid, Input } from 'semantic-ui-react';
import { Auth, Nav, Terminal } from '../../components';

function defaultServices(props) {
  if (props.match && props.match.params && props.match.params.services) {
    return props.match.params.services.split(',');
  }
  return [];
}

function getQuery({ location: { search } }) {
  const { query } = qs.parse(search.substring(1));
  return query || null;
}

class BaseLiveLogPage extends React.Component {
  state = {
    services: defaultServices(this.props),
    autoscroll: true,
    isLoading: false,
    entries: [],
    query: getQuery(this.props),
    knownServices: [
      'identity-serv', 'mobile-orchestration-api', 'payment-api', 'payment-serv',
      'secure-payment-serv', 'wex-serv',
    ].map(v => ({ key: v, text: v, value: v })),
  }

  componentDidMount() {
    const { match } = this.props;
    const { query } = this.state;
    if (match.params && match.params.services) {
      this.setupServices(match.params.services, query);
    }
  }

  componentWillUnmount() {
    if (this.sse) {
      this.sse.close();
    }
  }

  setupServices(services, query) {
    if (this.sse) {
      this.sse.close();
    }
    this.sse = new EventSource(
      `/system/logs/stream?services=${services}&query=${query || ''}`,
      { withCredentials: true },
    );
    this.sse.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data.logs && data.logs.length > 0) {
        this.entries = [
          ...this.entries || [],
          ...data.logs.reverse(),
        ];
        this.setState({ entries: this.entries });
      }
    };
  }

  setServices = (event, { value }) => {
    this.setState({ services: value });
  }

  setExtra = (e) => {
    this.setState({ query: e.target.value });
  }

  addService = (event, { value }) => {
    const { knownServices } = this.state;
    this.setState({
      knownServices: [
        ...knownServices,
        { key: value, text: value, value },
      ],
    });
  }

  search = () => {
    let q = '';
    const { query, services } = this.state;
    const { history } = this.props;
    if (query) {
      q = `?query=${encodeURIComponent(query)}`;
    }
    const servicesStr = services.join(',');
    history.push(`/system/live-logs/${encodeURIComponent(servicesStr)}${q}`);
    this.setupServices(services, query);
  }

  clear = () => {
    this.entries = [];
    this.setState({ entries: this.entries });
  }

  toggleScroll = () => {
    const { autoscroll } = this.state;
    this.setState({ autoscroll: !autoscroll });
  }

  render() {
    const { isLoading, entries, services, knownServices, autoscroll } = this.state;

    return (
      <Auth forRoles="admin.superuser,admin.system">
        <Nav>
          <div>
            <Grid padded columns="equal">
              <Grid.Row>
                <Grid.Column width={2}>
                  <Dropdown text="Settings" icon="settings" labeled button className="icon">
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={this.clear} text="Clear Screen" icon="delete" />
                      <Dropdown.Item onClick={this.toggleScroll} icon={autoscroll ? 'checkmark box' : ''} text="Autoscroll" />
                      <Dropdown.Header content="Additional Search Query" />
                      <Input
                        name="search"
                        icon="search"
                        iconPosition="left"
                        placeholder="(Lucene format)"
                        onChange={this.setExtra}
                        onClick={e => e.stopPropagation()}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </Grid.Column>
                <Grid.Column>
                  <Dropdown
                    fluid
                    multiple
                    search
                    selection
                    allowAdditions
                    button
                    placeholder="Select services to display..."
                    options={knownServices}
                    onChange={this.setServices}
                    onAddItem={this.addService}
                    defaultValue={services}
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <Button primary fluid onClick={this.search}>Search</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Dimmer.Dimmable as={Segment} dimmed={isLoading} basic style={{ position: 'absolute', top: '60px', left: 0, right: 0, bottom: 0 }}>
              <Dimmer active={isLoading}>
                <Loader />
              </Dimmer>

              <Terminal lines={entries} autoscroll={autoscroll} />
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseLiveLogPage.propTypes = {
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
  location: PT.shape({ search: PT.string }).isRequired,
  match: PT.shape({ params: PT.shape({ services: PT.string }) }),
};

BaseLiveLogPage.defaultProps = {
  match: null,
};

export const LiveLogs = withRouter(connect(({ logs }) => ({ logs }))(BaseLiveLogPage));
